import { env } from "../constants/env";
import { accountsActions } from "./accounts-slice";

export const fetchAllAccounts =  (companyId) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(`${env.primeBridgeUrl}/api/account/company/${companyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Getting accounts failed.");
      }

      const result = await response.json();

      return result;
    };

    try {
      const data = await sendRequest();
      dispatch(accountsActions.getAccounts({ allAccounts: data }));
    } catch (error) {
      console.log(error);
    }
  };
};

export const fetchAllMt4Accounts =  (companyId) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(`${env.primeBridgeUrl}/api/account/mt-4`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Getting accounts failed.");
      }

      const result = await response.json();

      return result;
    };

    try {
      const data = await sendRequest();
      dispatch(accountsActions.getMt4Accounts({ allMt4Accounts: data }));
    } catch (error) {
      console.log(error);
    }
  };
};

export const fetchAllOverviewAccounts =  (companyId) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(`${env.primeBridgeUrl}/api/account/company/overview/${companyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Getting accounts failed.");
      }

      const result = await response.json();

      return result;
    };

    try {
      const data = await sendRequest();
      dispatch(accountsActions.getOverviewAccounts({ allOverviewAccounts: data }));
    } catch (error) {
      console.log(error);
    }
  };
};

export const fetchAllManagementAccounts =  (companyId) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(`${env.primeBridgeUrl}/api/account/company/management/${companyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Getting accounts failed.");
      }

      const result = await response.json();

      return result;
    };

    try {
      const data = await sendRequest();
      dispatch(accountsActions.getManagementAccounts({ allManagementAccounts: data }));
    } catch (error) {
      console.log(error);
    }
  };
};


export const fetchAllLPGroups =  (companyId) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(`${env.primeBridgeUrl}/api/account/company/lp-groups/${companyId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Getting accounts failed.");
      }

      const result = await response.json();

      return result;
    };

    try {
      const data = await sendRequest();
      dispatch(accountsActions.getLPGroups({ lpGroups: data }));
    } catch (error) {
      console.log(error);
    }
  };
};

export const fetchAllMt5Accounts =  (page, limit) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(`${env.primeBridgeUrl}/api/account/mt-5?page=${page}&limit=${limit}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Getting accounts failed.");
      }

      const result = await response.json();

      return result;
    };

    try {
      const data = await sendRequest();
      dispatch(accountsActions.getMt5Accounts({ allMt5Accounts: data.accounts }));
    } catch (error) {
      console.log(error);
    }
  };
};


export const fetchSyncedAccounts =  (id, account) => {
  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(`${env.primeBridgeUrl}/api/account/sync-account/${id}/${account}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Getting accounts failed.");
      }

      const result = await response.json();

      return result;
    };

    try {
      const data = await sendRequest();
      dispatch(accountsActions.getSyncedAccounts({ syncedAccounts: data }));
    } catch (error) {
      console.log(error);
    }
  };
};


